module.exports = __webpack_public_path__ + "img/ellipse-icon-red.19c9c212.svg";